module.exports = __webpack_public_path__ + "static/media/PayTrailBlazer.0b15b96b.png";